import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { router } from './router';
import { AuthProvider } from './contexts/AuthContext';
import { syncDevToolsFromUrl } from './utils/devMode';
import './index.css';
import './styles/cosmic-cta.css';
import reportWebVitals from './reportWebVitals';

// Persist ?dev=1 / ?dev=0 before any component reads the dev-tools gate, so the
// Test Mode panel + autopilot stay hidden from real users but can be enabled
// per-device on staging.
syncDevToolsFromUrl();

// Loading fallback component
const LoadingFallback = () => (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    color: '#4f46e5'
  }}>
    <div style={{
      border: '4px solid rgba(79, 70, 229, 0.2)',
      borderLeftColor: '#4f46e5',
      borderRadius: '50%',
      width: '40px',
      height: '40px',
      animation: 'spin 1s linear infinite',
      marginBottom: '1rem'
    }}></div>
    <p>Loading...</p>
  </div>
);

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <AuthProvider>
        <Suspense fallback={<LoadingFallback />}>
          <RouterProvider router={router} />
        </Suspense>
      </AuthProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Force fresh build timestamp: 2025-01-18

// Suppress PWA install prompt in development (localhost)
if (process.env.NODE_ENV !== 'production' && typeof window !== 'undefined' && window.location && window.location.hostname === 'localhost') {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
  });
}